export const customAxisPlugin = {
  id: "customAxisPlugin",
  afterDraw(chart) {
    const ctx = chart.ctx;
    ctx.save();
    ctx.fillStyle = "#fff";
    ctx.font = "bold 10px Arial";
    ctx.textAlign = "center";

    // Left y axis title
    const yScale = chart.scales.y;
    if (yScale) {
      const x = yScale.left + 2 + yScale.width / 2;
      const y = yScale.top - 20;
      ctx.fillText("KWh", x, y);
    }

    // Right y1 axis title
    const y1Scale = chart.scales.y1;
    if (y1Scale) {
      const x = y1Scale.left - 2 + y1Scale.width / 2;
      const y = y1Scale.top - 20;
      ctx.fillText("kWh/m²", x, y);
    }

    // Right y2 axis title
    const y2Scale = chart.scales.y2;
    if (y2Scale) {
      const x = y2Scale.left + y2Scale.width / 2;
      const y = y2Scale.top - 20;
      ctx.fillText("SOC(%)", x, y);
    }

    ctx.restore();
  },
};
